import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import "./registerServiceWorker"

Vue.config.productionTip = false
Vue.config.devtools = true

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')